/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Radio } from '@mantine/core'

function GeneratedFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Radio
        checked={value == null}
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="generated"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Radio
        checked={value === 'true'}
        label={intl.formatMessage({
          id: 'generated',
          defaultMessage: 'Généré'
        })}
        name="generated"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Radio
        checked={value === 'false'}
        label={intl.formatMessage({
          id: 'manual',
          defaultMessage: 'Manuel'
        })}
        name="generated"
        onChange={handleChangeEvent(onChange)}
        value="false"
      />
    </Filter>
  )
}

export default GeneratedFilter
